import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import embedThemes from "../Config/embedThemes";

/**
 * Resolves the embed theme from the `client` URL search parameter.
 * Falls back to the `default` theme if the client is not found.
 */
const useEmbedTheme = () => {
  const location = useLocation();

  const theme = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const client = params.get("client");
    return embedThemes[client] || embedThemes.default;
  }, [location.search]);

  return theme;
};

export default useEmbedTheme;
